import * as React from 'react';

const SvgTwitter = (props) => (
  <svg
    width={16}
    height={14}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#Twitter_svg__a)'>
      <path
        d='M15.692 2.407a6.212 6.212 0 0 1-1.813.508 3.22 3.22 0 0 0 1.388-1.783c-.62.376-1.297.64-2.004.782A3.123 3.123 0 0 0 10.959.897c-1.743 0-3.156 1.442-3.156 3.221 0 .253.028.499.081.735-2.623-.135-4.949-1.417-6.505-3.367a3.258 3.258 0 0 0-.428 1.62c0 1.118.558 2.104 1.404 2.682a3.095 3.095 0 0 1-1.43-.403v.04c0 1.561 1.089 2.863 2.532 3.16a3.098 3.098 0 0 1-1.425.055c.402 1.28 1.567 2.211 2.949 2.237a6.252 6.252 0 0 1-4.673 1.334 8.802 8.802 0 0 0 4.838 1.448c5.806 0 8.98-4.91 8.98-9.167 0-.14-.003-.279-.009-.417a6.489 6.489 0 0 0 1.575-1.668Z'
        fill='#fff'
      />
    </g>
    <defs>
      <clipPath id='Twitter_svg__a'>
        <path
          fill='#fff'
          transform='translate(.308 .846)'
          d='M0 0h15.385v12.82H0z'
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgTwitter;
